// extracted by mini-css-extract-plugin
export var activeFilterButton = "_n0-c";
export var backButton = "_n0-4";
export var backIcon = "_n0-5";
export var chevronShortcut = "_n0-6";
export var container = "_n0-1";
export var editor = "_n0-8";
export var editorWrapper = "_n0-7";
export var prefix = "_n0-2";
export var searchIcon = "_n0-3";
export var suffix = "_n0-9";
export var suffixContent = "_n0-a";
export var suffixText = "_n0-b";
export var wrapper = "_n0-0";